import { domainProvider } from '@mathflat/shared/@common/domain/domainProvider'
import type { LocalStorageDataT } from 'src/constant'

import { envUtils } from '../envUtils'
import { aiAxios } from './aiAxios'
import maxios from './maxios'
import noxios from './noxios'
import podAxios from './podAxios'
import { remoteStorageAxios } from './remoteStorage'
import { saiAxios } from './saiAxios'

// TODO: localStorageService 호출 시점이 너무 늦어서 localStorage로 대체
export const initAxiosDefaultBaseURL = (type: LocalStorageDataT['DEV_API'] | string) => {
  localStorage.setItem('DEV_API', type)
  switch (type) {
    case 'dev': {
      maxios.defaults.baseURL = `https://api-dev.${domainProvider.TARGET_DOMAIN}`
      noxios.defaults.baseURL = `https://messaging-api-dev.${domainProvider.TARGET_DOMAIN}`
      podAxios.defaults.baseURL = `https://pod-api-dev.${domainProvider.TARGET_DOMAIN}`
      remoteStorageAxios.defaults.baseURL = `https://remote-storage-dev.${domainProvider.TARGET_DOMAIN}`
      saiAxios.defaults.baseURL = `https://sai-dev.${domainProvider.TARGET_DOMAIN}`
      aiAxios.defaults.baseURL = `https://ai-dev.${domainProvider.TARGET_DOMAIN}`
      return
    }
    case 'stg': {
      maxios.defaults.baseURL = `https://api-staging.${domainProvider.TARGET_DOMAIN}`
      noxios.defaults.baseURL = `https://messaging-api-staging.${domainProvider.TARGET_DOMAIN}`
      podAxios.defaults.baseURL = `https://pod-api-staging.${domainProvider.TARGET_DOMAIN}`
      remoteStorageAxios.defaults.baseURL = `https://remote-storage-staging.${domainProvider.TARGET_DOMAIN}`
      saiAxios.defaults.baseURL = `https://sai-staging.${domainProvider.TARGET_DOMAIN}`
      aiAxios.defaults.baseURL = `https://ai-staging.${domainProvider.TARGET_DOMAIN}`
      return
    }

    case 'live': {
      maxios.defaults.baseURL = `https://api.${domainProvider.TARGET_DOMAIN}`
      noxios.defaults.baseURL = `https://messaging-api.${domainProvider.TARGET_DOMAIN}`
      podAxios.defaults.baseURL = `https://pod-api.${domainProvider.TARGET_DOMAIN}`
      remoteStorageAxios.defaults.baseURL = `https://remote-storage.${domainProvider.TARGET_DOMAIN}`
      saiAxios.defaults.baseURL = `https://sai.${domainProvider.TARGET_DOMAIN}`
      aiAxios.defaults.baseURL = `https://ai.${domainProvider.TARGET_DOMAIN}`
      return
    }

    default: {
      maxios.defaults.baseURL = type
      noxios.defaults.baseURL = `https://messaging-api-dev.${domainProvider.TARGET_DOMAIN}`
      podAxios.defaults.baseURL = `https://pod-api-dev.${domainProvider.TARGET_DOMAIN}`
      remoteStorageAxios.defaults.baseURL = `https://remote-storage-dev.${domainProvider.TARGET_DOMAIN}`
      saiAxios.defaults.baseURL = `https://sai-dev.${domainProvider.TARGET_DOMAIN}`
      aiAxios.defaults.baseURL = `https://ai-dev.${domainProvider.TARGET_DOMAIN}`
    }
  }
}
